import Link from "next/link";
import { pushMenuCLickEvent } from "@nju/data-layer";
import { Icon } from "@nju/icons";
import { A, Badge, Text } from "@nju/ui";
import { IHeaderMenuItemLinkProps } from "../types";

export function HeaderMenuMobileContentItemLink({
  href,
  title,
  badge,
  icon,
  additionalIcon,
  tabTitle,
}: IHeaderMenuItemLinkProps) {
  return (
    <div className="min-h-[27px] flex flex-row gap-2 pl-[27px] py-2">
      {(icon || additionalIcon) && (
        <div className="mr-2 flex items-center">
          {icon && <Icon height={24} name={icon} tone="accent" width={24} />}
          {additionalIcon && (
            <div className="flex gap-[2px] items-center">
              <Text size="l" tone="accent">
                +
              </Text>
              <Icon
                height={24}
                name={additionalIcon}
                tone="accent"
                width={24}
              />
            </div>
          )}
        </div>
      )}
      <Link
        href={href}
        id={`menu_nm_${tabTitle}_${title}`}
        onClick={() => {
          return pushMenuCLickEvent({ id: `menu_nm_${tabTitle}_${title}` });
        }}
        passHref={true}
      >
        <A size="inline" variant="neutral">
          <Text size="l" tone="neutral">
            {title}
          </Text>
        </A>
      </Link>
      {badge && (
        <Badge
          badgeText={badge?.title}
          fontSize={14}
          small={true}
          variant={badge.tone === "accent" ? "cerulean" : "yellow"}
        />
      )}
    </div>
  );
}
